import * as React from 'react';
import cx from 'classnames';
import { Flex } from '@common/components/Flex';
import { I18n } from 'react-redux-i18n';
import { Button } from '@common/components/Button';
import { getTestAttributes } from '@common/utils/tests';
import { MODULE_NAME } from '../../email-templates.constants';
import { Loading } from '@common/components/loading';

import './actions.styles.scss';

export type ActionsProps = {
  disabledState: {
    save: boolean;
    newTemplate: boolean;
    deleteTemplate: boolean;
    copyTemplate: boolean;
  };
  className?: string;
  onTemplateDelete: () => Promise<void>;
  onTemplateSave: () => Promise<void>;
  onTemplateCopy: () => Promise<void>;
  onTemplateCreate: () => void;
};

export const Actions: React.FC<ActionsProps> = (props) => {
  const { className, onTemplateDelete, disabledState, onTemplateSave, onTemplateCreate, onTemplateCopy } = props;
  const [loadingBtnIndex, setLoadingBtnIndex] = React.useState<number | undefined>(undefined);

  const handleAction = React.useCallback((fn: () => Promise<void> | void, index: number) => async () => {
    setLoadingBtnIndex(index);
    await fn();
    setLoadingBtnIndex(undefined);
  }, []);

  const actions = [
    {
      iconSrc: 'gif/save.gif',
      label: 'Save',
      disabled: disabledState.save,
      onClick: onTemplateSave,
    },
    {
      iconSrc: 'gif/questionnaire_add.gif',
      label: 'New Template',
      disabled: disabledState.newTemplate,
      onClick: onTemplateCreate,
    },
    {
      iconSrc: 'gif/questionnaire_delete.gif',
      label: 'Delete Template',
      disabled: disabledState.deleteTemplate,
      onClick: onTemplateDelete,
    },
    {
      iconSrc: 'gif/questionnaire_copy.gif',
      label: 'Copy Template',
      disabled: disabledState.copyTemplate,
      onClick: onTemplateCopy,
    },
  ].map(({ label, onClick, ...restData }, index) => ({ 
    ...restData, 
    label: I18n.t(label),
    onClick: onClick ? handleAction(onClick, index) : undefined,
  }));

  return (
    <Flex 
      className={cx(
        'EmailTemplatesActions', 
        { 
          'EmailTemplatesActions--disabled': loadingBtnIndex !== undefined,
        }, 
        className
      )} 
      alignItems="center">
      {actions.map(({ iconSrc, label, ...btnProps }, index) => (
        <Button
          key={label}
          className="EmailTemplatesActions__btn"
          {...getTestAttributes(MODULE_NAME, 'action', 'button', label.toLowerCase().replace(' ', '-'))}
          {...btnProps}
        >
          {loadingBtnIndex !== index 
            ? <img src={iconSrc} />
            : <Loading size={16} />}
          {I18n.t(label)}
        </Button>
      ))}
    </Flex>
  );
};